import React from 'react'
import {Button, Layout, message, Space, Spin, Table, Upload} from "antd";
import HeaderNav from "../../header/header";
import {PlusOutlined} from "@ant-design/icons";
import "../css/FinancialClaimMassUpload.css"
import {claims_create, financial_mass_upload} from "../../../requist";
const { Content } = Layout;

const downLoadFiles={
    "template":'assets/downLoadFile/Batch_Financial_Claim_template.xlsx',
    "instruction":'assets/downLoadFile/Batch_Financial_Claim_Instruction.xls',
}
const columns=[
    {
        title: 'Claim Request No',
        dataIndex: 'claimReqNo',
        width:200,
    },
    {
        title: 'Claim ID',
        dataIndex: 'claimId',
        width:200,
    },
    {
        title: 'Claim Item Number',
        dataIndex: 'claimItemNo',
        width:200,
    },
    {
        title: 'Processing Log',
        dataIndex: 'processingLog',
        width:200,
    },
    {
        title: 'Claim Type',
        dataIndex: 'claimType',
        width:200,
    },
    {
        title: 'Claim Category',
        dataIndex: 'claimCategory',
        width:200,
    },
    {
        title: 'Sales Org',
        dataIndex: 'salesOrg',
        width:200,
    },
    {
        title: 'Channel',
        dataIndex: 'channel',
        width:200,
    },
    {
        title: 'Sales Office',
        dataIndex: 'salesOffice',
        width:200,
    },
    {
        title: 'SBO-No / SOP Ref. /LENOVO Ref.',
        dataIndex: 'lenovoRef',
        width:200,
    },
    {
        title: 'BP-Reference',
        dataIndex: 'bpRef',
        width:200,
    },
    {
        title: 'Sold To Party',
        dataIndex: 'soldTo',
        width:200,
    },
    {
        title: 'Bill To Party',
        dataIndex: 'billTo',
        width:200,
    },
    {
        title: 'Customer Purchase Order Number',
        dataIndex: 'poNumber',
        width:200,
    },
    {
        title: 'Currency',
        dataIndex: 'currency',
        width:200,
    },
    {
        title: 'Invoice No.',
        dataIndex: 'invoiceNo',
        width:200,
    },
    {
        title: 'Requested Delivery Date',
        dataIndex: 'reqDeliveryDate',
        width:200,
    },
    {
        title: 'Pricing Date',
        dataIndex: 'pricingDate',
        width:200,
    },
    {
        title: 'Email',
        dataIndex: 'email',
        width:200,
    },
    {
        title: 'Material',
        dataIndex: 'partNumber',
        width:200,
    },
    {
        title: 'Quantity',
        dataIndex: 'quantity',
        width:200,
    },
    {
        title: 'Unit Claim Value',
        dataIndex: 'unitClaimValue',
        width:200,
    },
    {
        title: 'Claim Value',
        dataIndex: 'claimValue',
        width:200,
    },
    {
        title: 'End User Name',
        dataIndex: 'endUserName',
        width:200,
    },
    {
        title: 'Serial Number',
        dataIndex: 'serialNumber',
        width:200,
    },
    {
        title: 'Comment',
        dataIndex: 'comment',
        width:200,
    },
    {
        title: 'Billing Instruction',
        dataIndex: 'billingInstruction',
        width:200,
    },
    {
        title: 'Ship To Party',
        dataIndex: 'shipTo',
        width:200,
    },
    {
        title: 'Collection Address 1',
        dataIndex: 'street',
        width:200,
    },
    {
        title: 'Collection Address 2',
        dataIndex: 'street2',
        width:200,
    },
    {
        title: 'Zip Code',
        dataIndex: 'postalCode',
        width:200,
    },
    {
        title: 'City',
        dataIndex: 'city',
        width:200,
    },
    {
        title: 'Country',
        dataIndex: 'country',
        width:200,
    },
    {
        title: 'Contact Person',
        dataIndex: 'contactPerson',
        width:200,
    },
    {
        title: 'Phone number',
        dataIndex: 'phoneNo',
        width:200,
    },
    {
        title: 'CMR Number',
        dataIndex: 'cmrNo',
        width:200,
    },
    {
        title: 'Claim Reference Number',
        dataIndex: 'claimRefNo',
        width:200,
    }
]
class FinancialClaimMassUpload extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            tableVisible:false,
            errorDataTable:false,
            file:null,
            dataSource:[],
            loading:false,
            callBackMsg:'',
            callBackCode:'',
            selectedRowKeys:[],
            selectedRows:[],
            selected:false,
            submitDisabled:true,
            buttonDisabled:false
        }
    }
    componentWillMount(){
        let uesrId = window.localStorage.getItem('userId')
        if(!uesrId){
            message.warn('Please log in first!')
            this.props.history.push({
                pathname: '/disputeHome'
            })
        }
    }
    fileMassProps=()=>{
        let that = this
        return {
            name: 'file',
            maxCount:1,
            className:"avatar-uploader",
            beforeUpload(file,fileList){
                return false
            },
            onChange(info) {
                if (info.file.status !== 'uploading') {
                    that.setState({file:info.file})
                }
                if (info.file.status === 'done') {
                    message.success(`${info.file.name} file uploaded successfully`);
                } else if (info.file.status === 'error') {
                    message.error(`${info.file.name} file upload failed.`);
                }
            },
        };
    }
    upload=()=>{
        const {file} = this.state;
        let data = new FormData();
        data.append('file',file)
        this.setState({loading:true,buttonDisabled:false})
        financial_mass_upload(data,false).then(res=>{
            const {retCode,retMsg,data}=res;
            if(retCode==="200"){
                this.setState({loading:false})
                if(data.code==='100'){
                    this.setState({
                        dataSource:data.claims,
                        tableVisible:true,
                        errorDataTable:false,
                        callBackMsg:data.message,
                        callBackCode:'100'
                    })
                }else if(data.code==='101'){
                    this.setState({
                        dataSource:data.errorDetail,
                        tableVisible:false,
                        errorDataTable:true,
                        callBackMsg:data.message,
                        callBackCode:'101'
                    })
                }else if(data.code==='200'){
                    this.setState({
                        dataSource:data.claims,
                        tableVisible:true,
                        errorDataTable:false,
                        callBackMsg:data.message,
                        callBackCode:'200',
                        buttonDisabled:true
                    })
                }
                // message.success(`${retMsg}`)
            }else{
                message.warn(`${retMsg}`)
                this.setState({loading:false,callBackMsg:retMsg})
            }
        })
    }
    handleDelete=()=>{
        const dataSource = [...this.state.dataSource];
        const {selectedRowKeys} = this.state;
        selectedRowKeys.map(k=>{
            return dataSource.splice(dataSource.findIndex(item => item.createSeqId === k), 1)
        }).every(()=>{
            this.setState({ dataSource: dataSource});
        })
    };
    keepMarked=()=>{
        let {dataSource,selected,selectedRows} = this.state;
        if(selected){
            this.setState({ dataSource: dataSource.map(item=>{
                    return {
                        ...item,
                        processingLog:''
                    }
                }),submitDisabled:false});
        }else{
            selectedRows.map(k=>{
                dataSource = dataSource.map(item=>{
                    if(item.createSeqId===k.createSeqId){
                        return {
                            ...item,
                            processingLog:''
                        }
                    }else{
                        return item
                    }
                })
            }).every(()=>{
                this.setState({
                    dataSource: dataSource,
                    submitDisabled:!dataSource.every(item=>{
                        return item.processingLog===''
                    }),
                    selectedRows:selectedRows.map(item=>{
                        return {
                            ...item,
                            processingLog:''
                        }
                    })
                });
            })
        }
    }
    onSelectChange = (selectedRowKeys,selectedRows) => {
        const {buttonDisabled,dataSource}=this.state;
        let submitDisabled = dataSource.every(item=>{
            return item.processingLog===''
        })
        if (buttonDisabled){
            this.setState({
                selectedRowKeys:selectedRowKeys,
                selectedRows:selectedRows,
                submitDisabled:true
            });
        }else{
            this.setState({
                selectedRowKeys:selectedRowKeys,
                selectedRows:selectedRows,
                submitDisabled:!submitDisabled
            });
        }

    };
    onSelectAll=(selected)=>{
        this.setState({selected:selected})
    }
    onSubmit=()=>{
        this.setState({loading:true})
        let {dataSource,selectedRows,selected}=this.state;
        let userId = window.localStorage.getItem('userId')
        let value={
            action:'',
            // claims:selected?dataSource:selectedRows,
            claims:dataSource,
            userId:userId,
            cbso:false
        }
        claims_create(value).then(res=>{
            const {retCode,retMsg,data}=res;
            if(retCode==='200'){
                if(data.code==="200"){
                    this.setState({
                        loading:false,
                        selectedRowKeys:[],
                        selectedRows:[],
                        callBackMsg:data.message,
                        callBackCode:'200',
                        submitDisabled:true,
                        buttonDisabled:true,
                        dataSource:data.claims
                    })
                    // message.success(`${data.message}`)
                }else{
                    this.setState({
                        loading:false,
                        buttonDisabled:false,
                        dataSource:data.claims
                    })
                }
            }else{
                this.setState({loading:false,buttonDisabled:false})
                message.error(`${retMsg}`)
            }
        })
    }
    render() {
        const {tableVisible,dataSource,loading,buttonDisabled,callBackMsg,callBackCode,errorDataTable,selectedRowKeys,submitDisabled} = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
            onSelectAll:this.onSelectAll
        };
        return <div>
            <HeaderNav parmas={'/financialClaimMassUpload'}/>
            <Layout className="site-layout-background FinancialClaimMassUpload" style={{ padding: '24px 0' }}>
                <div className="example" style={{display:loading?'block':'none'}}>
                    <Spin spinning={loading} />
                </div>
                <Content style={{ padding: '0 24px', minHeight: 280, width:'950px',margin:'0 auto' }}>
                    <h1>Batch Financial Claim</h1>
                    <Upload
                        {...this.fileMassProps()}
                    >
                        <p>
                            <a onClick={(e)=>{e.stopPropagation()}} href={downLoadFiles.template} download={'Batch_financial_Claim_template'}>
                                Please download template for request format
                            </a>
                            <br/>
                            <a onClick={(e)=>{e.stopPropagation()}} href={downLoadFiles.instruction} download={'Upload_template_Instruction'}>
                                This is the template instruction
                            </a>
                        </p>
                        <ol>
                            <li>File must be in XLSX format</li>
                            <li>All date fields must be formatted as yyyymmdd</li>
                            <li>Click the browse button below</li>
                            <li>Navigate to the appropriate directory in your system</li>
                            <li>Select the file to Upload</li>
                            <li>Click open</li>
                            <li>Click the upload button below</li>
                        </ol>
                        <div className="upload_icon">
                            <PlusOutlined />
                            <br/>
                            <div style={{ marginTop: 8 }}>Upload</div>
                        </div>
                    </Upload>
                    <Space>
                        <Button type="primary" onClick={this.upload} style={{marginTop:20,marginLeft:325}}>Upload</Button>
                    </Space>
                </Content>
                {
                    callBackCode==='100' || callBackCode==='101'?
                        <h2 style={{marginTop:20,color:'#dc291e'}}>{callBackMsg}</h2>
                        :
                        <h2 style={{marginTop:20,color:'green'}}>{callBackMsg}</h2>
                }
                {tableVisible?
                    <div>
                        <Space>
                            <Button type="primary" style={{marginTop:20}} disabled={submitDisabled} onClick={this.onSubmit}>Submit</Button>
                            <Button type="primary" style={{marginTop:20,marginLeft:5}} disabled={buttonDisabled} onClick={this.handleDelete}>Delete Marked</Button>
                            <Button type="primary" style={{marginTop:20,marginLeft:5}} disabled={buttonDisabled} onClick={this.keepMarked}>Keep Marked</Button>
                        </Space>
                        <Table
                            scroll={{y: 500}}
                            rowKey={'createSeqId'}
                            style={{marginTop: 20}}
                            columns={columns}
                            rowSelection={rowSelection}
                            dataSource={dataSource}
                            bordered
                        />
                    </div>
                    :''}
                {
                    errorDataTable?
                        <Table
                            scroll={{ y: 500}}
                            rowKey={'id'}
                            style={{marginTop: 20}}
                            columns={[
                                {
                                    title:'line',
                                    dataIndex:'line'
                                },
                                {
                                    title:'Column Name',
                                    dataIndex:'columnName'
                                },
                                {
                                    title:'Description',
                                    dataIndex:'errorMsg'
                                }
                            ]}
                            dataSource={dataSource}
                            bordered
                        />:''
                }
            </Layout>
        </div>

    }
}

export default FinancialClaimMassUpload;